export const NAME = 'notification';
